import type { GuestInvitationDto, RecentGuest } from '@hub-wifi/shared'
import { apiRequest } from './client'

export interface CreateGuestInvitationBody {
  guestName: string
  guestEmail?: string | null
  guestPhone?: string | null
  visitDate: string
  visitTimeBegin: string
  visitTimeEnd: string
  singleAccess?: boolean
}

export function listGuestInvitations(token: string): Promise<GuestInvitationDto[]> {
  return apiRequest<GuestInvitationDto[]>('/api/guest-invitations', { token })
}

export function listRecentGuests(token: string): Promise<RecentGuest[]> {
  return apiRequest<RecentGuest[]>('/api/guest-invitations/recent-guests', { token })
}

export function createGuestInvitation(
  body: CreateGuestInvitationBody,
  token: string,
): Promise<GuestInvitationDto> {
  return apiRequest<GuestInvitationDto>('/api/guest-invitations', {
    method: 'POST',
    body,
    token,
  })
}
